// src/app/interceptors/error-normalizer.interceptor.ts
import { HttpErrorResponse, HttpEvent, HttpInterceptorFn } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export const errorNormalizerInterceptor: HttpInterceptorFn = (req, next): Observable<HttpEvent<unknown>> => {
  return next(req).pipe(
    catchError((err: unknown) => {
      if (err instanceof HttpErrorResponse) {
        // 1) Offline
        if (navigator.onLine === false) {
          return throwError(() => ({ ...err, error: { code: 'OFFLINE', message: 'No internet connection' } }));
        }
        // 2) Network-layer failure
        if (err.status === 0) {
          return throwError(() => ({ ...err, error: { code: 'NETWORK_ERROR', message: 'Network error. Please try again.' } }));
        }
        // 3) Server responded
        const code = err.error?.code || `HTTP_${err.status}`;
        const message =
          err.error?.message ||
          (err.status >= 500 ? 'Server unavailable. Try again later.' : err.message || 'Request failed');

        return throwError(() => ({ ...err, error: { code, message } }));
      }

      // Non-HTTP error
      if (navigator.onLine === false) {
        return throwError(() => ({ error: { code: 'OFFLINE', message: 'No internet connection' } }));
      }
      return throwError(() => ({ error: { code: 'UNKNOWN', message: 'Unexpected error' } }));
    })
  );
};
